import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';
import SbEditable from 'storyblok-react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

import LinkWrap from '../link_wrap';
import { ReactComponent as Blog } from './blog-solid.svg';
import { ReactComponent as Facebook } from './facebook-brands.svg';
import { ReactComponent as Twitter } from './twitter-square-brands.svg';
import './footer.scss';
import {
  DESIGN_MY_SYSTEM_TEXT,
  LEARNING_CENTER_TEXT,
  getFooterPowerProAndLearningCenter,
  getPowerProFields,
} from '../../utils/getPowerProFields';

const Footer = (props) => {
  const {
    sbx_show_design_my_system,
    show_design_my_system,
    sbx_design_my_system_url,
    design_my_system_url,
    sbx_show_learning_center,
    show_learning_center,
    sbx_learning_center_url,
    learning_center_url,
  } = props.powerProData || {};

  const designMySystem = getFooterPowerProAndLearningCenter(
    {
      show_design_my_system,
      design_my_system_url,
      show_learning_center,
      learning_center_url,
      sbx_design_my_system_url,
      sbx_learning_center_url,
      sbx_show_design_my_system,
      sbx_show_learning_center,
      navItems: props.naviItems || [],
    },
    DESIGN_MY_SYSTEM_TEXT
  );

  const learningCenter = getFooterPowerProAndLearningCenter(
    {
      show_design_my_system,
      design_my_system_url,
      show_learning_center,
      learning_center_url,
      sbx_design_my_system_url,
      sbx_learning_center_url,
      sbx_show_design_my_system,
      sbx_show_learning_center,
      navItems: props.naviItems || [],
    },
    LEARNING_CENTER_TEXT
  );

  return (
    <SbEditable content={props.blok}>
      <footer>
        <div className="footer-links">
          <ul>
            <li>
              <h3>Company</h3>
              <ul>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/how-home-batteries-work">How Home Batteries Work</Link>
                </li>
                <li>
                  <Link to="/how-to-store-solar-energy">How to Store Solar Energy</Link>
                </li>
                <li>
                  <Link to="/jobs">Careers at Swell Energy</Link>
                </li>
                <li>
                  <a href="https://swell-energy.typeform.com/to/rmtutYkq">Subscribe</a>
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              <h3> Resources</h3>
              <ul>
                {designMySystem?.link && (
                  <li>
                    <a href={designMySystem.link}>Design my system</a>
                  </li>
                )}

                <li>
                  <Link to="/faq">FAQ</Link>
                </li>
                {learningCenter?.link && (
                  <li>
                    <a href={learningCenter.link}>Knowledge Base</a>
                  </li>
                )}
                <li>
                  <a href="https://compass.swellenergy.com/">Login</a>
                </li>
                <li>
                  <Link to="/press">Press Room</Link>
                </li>
                <li>
                  <Link to="/technology">Technology</Link>
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              <h3>Join Swell Energy</h3>
              <ul className="partner">
                <li>
                  <h4>Partners:</h4>{' '}
                  <p>
                    Our preferred partner network creates industry-wide opportunities through
                    installation partnerships, VPP Co-Development, financing programs, and
                    technology.
                  </p>{' '}
                  <Link to="/partners">Learn More</Link>
                </li>
                <li>
                  <h4>Utilities:</h4>{' '}
                  <p>
                    Swell Energy partners with Investor-owned Utilities, Municipal Utilities,
                    Utility Cooperatives, Retail Energy Providers, and Community Choice Aggregators
                    (CCA).{' '}
                  </p>
                  <Link to="/utilities">Learn More</Link>
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              <h3>Latest News</h3>
              <ul>
                {props.data &&
                  props.data.allStoryblokEntry &&
                  props.data.allStoryblokEntry.edges &&
                  props.data.allStoryblokEntry.edges.map((v, idx) => (
                    <li key={`footer-news-${idx}`}>
                      <LinkWrap
                        to={v.node.field_link_url_string || '/' + v.node.full_slug}
                        openInNewWindow={true}
                      >
                        {v.node.field_title_string}
                      </LinkWrap>
                    </li>
                  ))}
              </ul>
            </li>
          </ul>
        </div>
        <div className="footer-copyright">
          <div>
            <p className="license-info">Swell Energy Inc. CSLB Lic. # 1021183</p>
            <p>
              © 2016 - 2021 Swell Energy. All rights reserved ·{' '}
              <Link to="/privacy-policy">Privacy Policy</Link>
            </p>
          </div>
          <div className="social-chiclets">
            <OutboundLink href="https://www.facebook.com/swellenergy" target="_blank">
              <Facebook />
            </OutboundLink>
            <OutboundLink href="https://twitter.com/Swell_Energy" target="_blank">
              <Twitter />
            </OutboundLink>
            <Link to="/blog">
              <Blog />
            </Link>
          </div>
          <div className="bbb-badge">
            <a
              target="_blank"
              id="bbblink"
              className="ruhzbul"
              href="https://www.bbb.org/us/ca/santa-monica/profile/general-contractor/swell-services-1216-679359#bbbseal"
              title="Swell Services, Inc., General Contractor, Santa Monica, CA"
              style={{
                display: 'block',
                position: 'relative',
                overflow: 'hidden',
                width: '200px',
                height: '90px',
                margin: '0px',
                padding: '0px',
              }}
            >
              <img
                style={{ padding: '0px', border: 'none' }}
                id="bbblinkimg"
                src="https://seal-sanjose.bbb.org/logo/ruhzbul/swell-services-679359.png"
                width="400"
                height="90"
                alt="Swell Services, Inc., General Contractor, Santa Monica, CA"
              />
            </a>
            <script
              dangerouslySetInnerHTML={{
                __html: `var bbbprotocol = ( ("https:" == document.location.protocol) ? "https://" : "http://" ); (function(){var s=document.createElement('script');s.src=bbbprotocol + 'seal-sanjose.bbb.org' + unescape('%2Flogo%2Fswell-services-679359.js');s.type='text/javascript';s.async=true;var st=document.getElementsByTagName('script');st=st[st.length-1];var pt=st.parentNode;pt.insertBefore(s,pt.nextSibling);})();`,
              }}
            />
          </div>
        </div>
      </footer>
    </SbEditable>
  );
};

//export default Footer

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        allStoryblokEntry(
          limit: 3
          filter: { field_component: { regex: "/(press_release)|(press_news_mention)/" } }
          sort: { fields: field_publish_date_string, order: DESC }
        ) {
          edges {
            node {
              id
              field_title_string
              full_slug
              field_link_url_string
            }
          }
        }
      }
    `}
    render={(data) => <Footer data={data} {...props} />}
  />
);
